<sdps-modal-beta sticky-footer sdps-title="Printer Friendly Page" id="{{modalId}}">
  <div slot="modal-body">
    <div slot="modal-content">
      <div class="svg-container">
        <div class="schwabSvg" [innerHTML]="svg"></div>
      </div>
      <div class="container">
        <div class="print-friendly-text master-account" data-testid="printFriendlyMasterAccountNumber">Master Account: <strong data-testid="masterAccountNumber">{{accountNumber}}</strong></div>
        <div class="print-friendly-text table-name"><strong>Move Money - Master Status</strong></div>
        <div class="print-friendly-text master-disclaimer-text" *ngIf="masterTableName === 'Status' else recurringDisclaimerText" id="table-header" data-testid="transactionStatusTableDisclaimer">
          <p><strong>Note:</strong> For Position Internal Transfers entered online that are still in Pending or Approved
            Status, the
            Amount field is the estimated value and will be updated with the final position values at the time of
            Internal Transfer
            completion. </p>
          <p> Inactive ACH Set-Ups that can be reactivated are displayed within the Account Status view. <br>
            <strong>ACH Transactions -</strong> Process Date displays the date the transfer is initiated. <br>
            <strong>Note:</strong> All transactions may not appear on this status page depending on the transaction
            details and view for your master.
          </p>
        </div>
        <ng-template #recurringDisclaimerText>
          <div class="print-friendly-text master-disclaimer-text" id="table-header" data-testid="recurringTableDisclaimer">
            <p>
              <strong>Note:</strong> All transactions may not appear on this status page depending on the transaction
              details and view for your master.
            </p>
          </div>
        </ng-template>
        <div class="table-count"><span><strong>{{sortedMasterRows.length}} result(s)</strong></span></div>
        <div class="table-grid" [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }">
          <div class="header-row table-cell" *ngFor="let columnHeader of columnHeaders">{{columnHeader}}</div>
          <div class="table-cell" *ngFor="let row of rows">{{row}}</div>
        </div>
      </div>
    </div>
  </div>
  <div slot="modal-footer">
    <button (click)="onPrintButtonClicked()" type="button"
      class="sdps-button sdps-button--small sdps-button--secondary">Print</button>
  </div>
</sdps-modal-beta>
